/* eslint-disable import/no-named-as-default */
import { Extensions, getSchema } from '@tiptap/core';
import ListKeymap from '@tiptap/extension-list-keymap';
import Strike from '@tiptap/extension-strike';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { UniqueIDOptions } from '@tiptap/extension-unique-id';
import { Schema } from '@tiptap/pm/model';
import StarterKit from '@tiptap/starter-kit';
import { randomId } from '../../helpers/random-id';
import { CustomBulletList } from '../extensions/custom-bullet-list';
import { CustomListItem } from '../extensions/custom-list-item';
import { CustomOrderedList } from '../extensions/custom-ordered-list';
import { decorateSelection } from '../extensions/decorateSelection';
import { fillInTheBlanksBaseExtension } from '../extensions/fill-in-the-blanks-base-extension';

// curated list of extensions to use in fill in the blanks area
export const tipTapFillInTheBlanksBaseExtensions: Extensions = [
  StarterKit.configure({
    history: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    strike: false,
    heading: false,
    blockquote: false,
    horizontalRule: false,
    code: false,
    codeBlock: false,
  }),
  TextStyle, // Do we need this?
  Underline,
  CustomListItem,
  CustomOrderedList,
  CustomBulletList,
  ListKeymap,
  Strike,
  decorateSelection,
  Subscript,
  Superscript,
];

/** we need to set the filterTransaction in the editor, since we do not have access to the collaboration extension */
export const fillInTheBlanksUniqueIdOptions: Omit<UniqueIDOptions, 'filterTransaction'> = {
  attributeName: 'id',
  types: [fillInTheBlanksBaseExtension.name],
  generateID: () => randomId(),
};

export const tipTapFillInTheBlanksDataExtensions: Extensions = [
  ...tipTapFillInTheBlanksBaseExtensions,
  fillInTheBlanksBaseExtension,
];

export const tipTapFillInTheBlanksSchema: Schema = getSchema(tipTapFillInTheBlanksDataExtensions);
